import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import {Alert, Icon, Layout } from 'antd';

import AdminHeader from '../../components/AdminHeader/AdminHeader';
import Footer from '../../components/Footer/Footer';
import PatientProfileForm from '../../components/PatientProfileForm/PatientProfileForm';
import classes from './PatientProfileCreate.css';

import isAuthenticated from '../../utils/isAuthenticated';
import { getSubjectRequest } from '../../api/requests';
import { logout } from "../../reducers/user/actions";
import { getPatientProfileReadPermission } from "../../reducers/user/selectors";
import { withNamespaces } from 'react-i18next';

const { Content } = Layout;
// const { Search } = Input;

class PatientProfileCreate extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      subject: null,
      subjectSearch: null,
      subjectID: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      showRegistryForm: false,
      showRandomizeForm: false,
    };
  }

  componentDidMount() {
    const subjectID = get(this.props, 'match.params.subjectID');
    if (subjectID) {
      this.onSubjectSearch(subjectID);
      this.setState({ subjectSearch: subjectID });
    }
  }

  onSubjectSearch = async (value) => {

    if (value.trim()) {
      this.setState({ subjectID: value, errorMessage: null, subject: null, isLoading: true, responseMessage: null });
      try {
        const { data } = await getSubjectRequest(value);
        this.setState({
          subject: { ...data, profile: data.profile ? { ...data.profile } : null },
        });
      } catch (e) {
        if (get(e, 'response.status') === 401) { this.props.logout();  return; }
        this.setState({ subject: null, errorMessage: get(e, 'response.data.error', 'Error') });
      }

      this.setState({ isLoading: false });
    }
  };

  onProfileDelete = () => {
    this.setState({ subject: null, responseMessage: this.props.i18n.t('Successfully deactivated') });
  };

  onSubjectChange = (e) => {
    this.setState({ subjectSearch: e.target.value });
  };

  collapseSection = sectionName => () => {
    this.setState(state =>({ [sectionName]: !state[sectionName] }));
  };

  render() {
    const { subject, subjectID, errorMessage, isLoading, responseMessage, subjectSearch, showRegistryForm, showRandomizeForm } = this.state;
    const { patientProfileReadPermission } = this.props;

    return (
        <div style={{ backgroundColor: '#FAFAFA' }}>
            <Layout className={classes.parentContainer}>

                <Content className={classes.content}>
                  <h3 className='headline-default'>{this.props.i18n.t('NamespacePatientProfileCreate:Create patient profile')}</h3>

                  {!patientProfileReadPermission && (<Alert type='error' message={this.props.i18n.t('Permission denied! You cannot perform this action.')} />)}


                  {patientProfileReadPermission && (
                    <div>
                      {/*<div className={classes.searchWrapper}>
                        <label>
                          <b className={classes.searchWrapperLabel}>SEARCH</b>
                          <Search
                            placeholder={this.props.i18n.t("By subject ID")}
                            enterButton={this.props.i18n.t("Search")}
                            size="large"
                            onSearch={this.onSubjectSearch}
                            value={subjectSearch}
                            onChange={this.onSubjectChange}
                            style={{ maxWidth: '500px'}}
                          />
                        </label>
                      </div>*/}

                      {errorMessage && (<Alert type='error' message={errorMessage} />)}

                      {responseMessage && (<Alert type='success' message={responseMessage} />)}

                      <PatientProfileForm isNew onSubmit={this.onSubjectSearch} onProfileDelete={this.onProfileDelete} history={this.props.history} />

                      {isLoading && <Icon type="loading" />}
                    </div>
                  )}

                </Content>

            </Layout>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  patientProfileReadPermission: getPatientProfileReadPermission(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(PatientProfileCreate)));



// WEBPACK FOOTER //
// ./src/containers/PatientProfileCreate/PatientProfileCreate.js